import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import {
  setArticleGroupDiscount,
  setArticleGroupDiscountList,
  setIsWaitingArticleGroupDiscountGetResponse,
  setIsWaitingArticleGroupDiscountPostResponse,
  setIsWaitingArticleGroupDiscountPutResponse,
} from "../slices/articleGroupDiscountSlice";
import { getApiUrl } from "../helpers/environmentHelper";
import { ArticleGroupDiscount } from "../../models/responses/articleGroupDiscount";
import { acquireApiToken } from "../helpers/apiTokenHelper";

export const getArticleGroupDiscounts =
  (instance: IPublicClientApplication, account: AccountInfo | null) =>
  async (dispatch: AppDispatch) => {
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingArticleGroupDiscountGetResponse(true));
    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          if (response) {
            const getData: ArticleGroupDiscount[] = (
              await axios.get(`${baseUrl}/article-group-discount`, {
                timeout: 10000,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${response.accessToken}`,
                },
              })
            ).data;
            dispatch(
              setArticleGroupDiscountList({ articleGroupDiscounts: getData }),
            );
            dispatch(setIsWaitingArticleGroupDiscountGetResponse(false));
          }
        });
      }
    } catch (error) {
      dispatch(setIsWaitingArticleGroupDiscountGetResponse(false));
      console.log(error);
    }
  };

export const getArticleGroupDiscountById =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    id: string | undefined,
  ) =>
  async (dispatch: AppDispatch) => {
    if (!id) return;
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingArticleGroupDiscountGetResponse(true));

    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          if (response) {
            const getData: ArticleGroupDiscount = (
              await axios.get(`${baseUrl}/article-group-discount/${id}`, {
                timeout: 10000,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${response.accessToken}`,
                },
              })
            ).data;
            dispatch(
              setArticleGroupDiscount({ articleGroupDiscount: getData }),
            );
            dispatch(setIsWaitingArticleGroupDiscountGetResponse(false));
          }
        });
      }
    } catch (error) {
      dispatch(setIsWaitingArticleGroupDiscountGetResponse(false));
      console.log(error);
    }
  };

export const postArticleGroupDiscount =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    articleGroupDiscount: ArticleGroupDiscount,
    onSuccess: (articleGroupDiscountId: string | null) => void,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch(setIsWaitingArticleGroupDiscountPostResponse(true));
    const baseUrl = getApiUrl(window.location.hostname, 2);
    let responseId: string | null = null;

    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          try {
            if (response) {
              const apiArticleGroupDiscount = {
                ...articleGroupDiscount,
              };
              const responseData = await axios.post(
                `${baseUrl}/article-group-discount`,
                apiArticleGroupDiscount,
                {
                  timeout: 10000,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${response.accessToken}`,
                  },
                },
              );

              if (responseData.status === 201) {
                let locationArray = responseData.headers["location"].split("/");
                responseId = locationArray[locationArray.length - 1];
              }
            }
          } finally {
            onSuccess(responseId);
            dispatch(setIsWaitingArticleGroupDiscountPostResponse(false));
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

export const putArticleGroupDiscount =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    articleGroupDiscount: ArticleGroupDiscount,
    onSuccess: (articleGroupDiscountId: string | null) => void,
  ) =>
  async (dispatch: AppDispatch) => {
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingArticleGroupDiscountPutResponse(true));
    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          try {
            if (response) {
              const apiArticleGroupDiscount = {
                ...articleGroupDiscount,
              };
              const responseData = await axios.put(
                `${baseUrl}/article-group-discount/${articleGroupDiscount.id}`,
                apiArticleGroupDiscount,
                {
                  timeout: 10000,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${response.accessToken}`,
                  },
                },
              );
              if (responseData.status === 204) {
                onSuccess(articleGroupDiscount.id);
              }
            }
          } finally {
            onSuccess(articleGroupDiscount.id);
            dispatch(setIsWaitingArticleGroupDiscountPutResponse(false));
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
